import { Instagram } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { FOOTER } from "@/constants/testIds";
import { ASSETS } from "@/lib/assets";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-[#050505] text-white border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="" className="h-12 w-12 object-contain" />
            <div className="leading-tight">
              <div className="font-serif text-lg tracking-[0.18em]">STANIMIROVIĆ</div>
              <div className="text-[10px] tracking-[0.34em] text-white/45">{t.footer.tag}</div>
            </div>
          </div>
          <p className="mt-6 font-serif italic text-[#c5a572] text-xl">{t.footer.slogan}</p>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/45 mb-3">
            {t.contact.address}
          </div>
          <div className="text-white/80 font-light">{t.footer.address}</div>
          <div className="mt-4 text-white/80 font-light">064 668 8850</div>
          <div className="mt-1 text-white/80 font-light">zarkostanimirovic75@gmail.com</div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/45 mb-3">Social</div>
          <a
            href="https://instagram.com/vina.stanimirovic"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-white/80 hover:text-[#c5a572] transition-colors"
          >
            <Instagram size={16} /> @vina.stanimirovic
          </a>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-[11px] tracking-[0.2em] uppercase text-white/40">
          <div>© {year} Porodična vinarija Stanimirović</div>
          <div>{t.footer.rights}</div>
        </div>
      </div>
    </footer>
  );
}
